export const visitStatuses = {
  OFFERED: 'offered',
  PENDING: 'pending',
  SCHEDULED: 'scheduled',
  OPEN: 'open',
  FINISHED: 'finished',
  COMPLETED: 'completed',
  MISSED: 'missed',
  APPROVED: 'approved',
  APPROVED_BUT_MISSED: 'approved_but_missed',
  REJECTED: 'rejected',
}

export const visitStatusLabels = {
  [visitStatuses.OFFERED]: 'Offered',
  [visitStatuses.PENDING]: 'Pending',
  [visitStatuses.SCHEDULED]: 'Scheduled',
  [visitStatuses.OPEN]: 'Open',
  [visitStatuses.FINISHED]: 'Open',
  [visitStatuses.COMPLETED]: 'Completed',
  [visitStatuses.MISSED]: 'Missed',
  [visitStatuses.APPROVED]: 'Approved',
  [visitStatuses.APPROVED_BUT_MISSED]: 'Approved',
  [visitStatuses.REJECTED]: 'Rejected',
}

export const visitStatusListOptions = [
  {
    label: visitStatusLabels[visitStatuses.OFFERED],
    value: visitStatuses.OFFERED,
  },
  {
    label: visitStatusLabels[visitStatuses.PENDING],
    value: visitStatuses.PENDING,
  },
  {
    label: visitStatusLabels[visitStatuses.SCHEDULED],
    value: visitStatuses.SCHEDULED,
  },
  {
    label: visitStatusLabels[visitStatuses.OPEN],
    value: `${visitStatuses.OPEN},${visitStatuses.FINISHED}`,
  },
  {
    label: visitStatusLabels[visitStatuses.COMPLETED],
    value: `${visitStatuses.COMPLETED},${visitStatuses.MISSED}`,
  },
  {
    label: visitStatusLabels[visitStatuses.APPROVED],
    value: `${visitStatuses.APPROVED},${visitStatuses.APPROVED_BUT_MISSED}`,
  },
  {
    label: visitStatusLabels[visitStatuses.REJECTED],
    value: visitStatuses.REJECTED,
  },
]

export const offerStatuses = {
  REJECTED: 'rejected',
  OFFERED: 'offered',
}

export const offerStatusLabels = {
  [offerStatuses.REJECTED]: 'Rejected',
  [offerStatuses.OFFERED]: 'Offered',
}

export const offerStatusListOptions = [
  {
    label: offerStatusLabels[offerStatuses.OFFERED],
    value: offerStatuses.OFFERED,
  },
  {
    label: offerStatusLabels[offerStatuses.REJECTED],
    value: offerStatuses.REJECTED,
  },
]
